<template>
  <a-modal
    :width="'91%'"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :destroyOnClose="true"
    :bodyStyle="bodyStyle"
    :dialog-style="{ top: '62px'}"
    @cancel="close"
    cancelText="关闭"
    :footer="null"
  >
    <a-tabs default-active-key="1" :activeKey="tabKey" @change="chartChange">
      <a-tab-pane key="1" tab="总览">
        <a-spin :spinning="spinning1" size="large">
          <div ref='tab1' id='tab1' style="padding-left: 30px">
            <div style="display: flex;align-items: center;justify-content: space-between">
              <img src="../assets/img/mq_logo.png" style="width: 120px;height: 38px" />
              <div class="rep-title">动态血糖监测报告</div>
              <div>
                <div style="display: flex;align-items: center">
                  <div class="small-point"></div>
                  <div style="margin-left: 8px" class="info-text">监测账号：</div>
                  <div class="info-text-1">{{basicInfo.monitorPhone}}</div>
                </div>
                <div style="display: flex;align-items: center">
                  <div class="small-point"></div>
                  <div style="margin-left: 8px" class="info-text">生成时间：</div>
                  <div class="info-text-1">{{getCreateTime}}</div>
                </div>
              </div>
            </div>
            <div :style="scrollbarStyle" class="chart-content" id='scrollBar' ref='scrollBar' >
              <div class="chart-title">{{getStartDate}}至{{getEndDate}} {{allDays}}</div>
              <div class="chart-border">
                <div class="chart-1">
                  <div>
                    <div class="chart-1-label-data update2" >
                      <div class="chart-number">{{basicInfo.avgSg}}</div>
                      <div class="chart-unit">mmol/L</div>
                      <div class="chart-des">血糖平均值</div>
                    </div>
                    <div class="chart-1-label-data update2" >
                      <div class="chart-number">{{basicInfo.avgEffectWaveRange}}</div>
                      <div class="chart-des">有效波幅</div>
                    </div>
                  </div>
                  <div  class="update1">
                    <div class="chart-1-label-data update3">
                      <div class="chart-number">{{basicInfo.sdSg}}</div>
                      <div class="chart-unit">SD</div>
                      <div class="chart-des">血糖标准差</div>
                    </div>
                    <div class="chart-1-label-data" style="margin-top: 65px;">
                      <div class="chart-number">{{basicInfo.tir}}</div>
                      <div class="chart-unit">%</div>
                      <div class="chart-des">TIR</div>
                    </div>
                  </div>
                  <div class="line-style"></div>
                  <div class="just-margin">
                    <div class="chart-1-label-data update3" >
                      <div class="chart-number">{{basicInfo.highBlood}}</div>
                      <div class="chart-unit">mmol/L</div>
                      <div class="chart-des">血糖最高值</div>
                    </div>
                    <div class="chart-1-label-data update3">
                      <div class="chart-number">{{basicInfo.lowBlood}}</div>
                      <div class="chart-unit">mmol/L</div>
                      <div class="chart-des">血糖最低值</div>
                    </div>
                  </div>
                  <div class="line-style"></div>
                  <div>
                    <div  class="line_dv" ref="line_dv" id="myChart"></div>
                    <div style="display: flex;flex-direction: column;align-items: center">
                      <div class="chart-number-2">高血糖占比:{{basicInfo.highPercent}}%</div>
                      <div class="chart-number-2">低血糖占比:{{basicInfo.lowPercent}}%</div>
                    </div>
                  </div>
                  <div class="line-style-1"></div>
                  <div class="update4">
                    <div style="display: flex;align-items: center">
                      <div class="small-point"></div>
                      <div style="margin-left: 8px" class="info-text">设备 ID：</div>
                      <div class="info-text">{{basicInfo.bleId}}</div>
                    </div>
                    <div style="display: flex;align-items: center;" class="update5">
                      <div class="small-point"></div>
                      <div style="margin-left: 8px" class="info-text">传感器ID：</div>
                      <div class="info-text">{{basicInfo.qrCode}}</div>
                    </div>

                    <div style="display: flex;align-items: center;" class="update3">
                      <div class="small-point"></div>
                      <div style="margin-left: 8px" class="info-text">APP名称：</div>
                      <div class="info-text">美奇血糖监测</div>
                    </div>
                    <div style="display: flex;align-items: center;" class="update5">
                      <div class="small-point"></div>
                      <div style="margin-left: 8px" class="info-text">手机系统：</div>
                      <div class="info-text">{{basicInfo.phoneType}}</div>
                    </div>

                    <div style="display: flex;align-items: center;" class="update3">
                      <div class="small-point"></div>
                      <div style="margin-left: 8px" class="info-text">姓名：</div>
                      <div class="info-text">{{basicInfo.name}}</div>
                    </div>
                    <div style="display: flex;align-items: center;" class="update5">
                      <div class="small-point"></div>
                      <div style="margin-left: 8px" class="info-text">性别：</div>
                      <div class="info-text">{{getSex(basicInfo.sex)}}</div>
                    </div>
                    <div style="display: flex;align-items: center;" class="update5">
                      <div class="small-point"></div>
                      <div style="margin-left: 8px" class="info-text">年龄：</div>
                      <div class="info-text">{{basicInfo.age}}</div>
                    </div>
                  </div>
                </div>
                <div style="height:1px;background-color: #999999;" class="update6"></div>
                <div class="chart-2">
                  <div style="display:flex;align-items:center" class="update7">
                    <div style="width:5px;height:26px;background-color:#009CEE;">
                    </div>
                    <div class="chart2-title">
                      连续图谱
                    </div>
                    <div style="display:flex;align-items:center;background-color: rgba(0,156,238,0.05);border-radius: 14px;margin-left:65px;padding:4px 15px;">
                      <img src="../assets/img/mq_can_bi_icon.png" style="width:15px;height:15px;" />
                      <div class="chart2-lengend">
                        参比
                      </div>
                      <img src="../assets/img/mq_eat_icon.png" style="width:15px;height:15px;margin-left:18px" />
                      <div class="chart2-lengend">
                        饮食
                      </div>
                      <img src="../assets/img/mq_medicine_icon.png" style="width:15px;height:15px;margin-left:18px" />
                      <div class="chart2-lengend">
                        用药
                      </div>
                      <img src="../assets/img/mq_work_out_icon.png" style="width:15px;height:15px;margin-left:18px" />
                      <div class="chart2-lengend">
                        锻炼
                      </div>
                    </div>
                  </div>
                  <div style="display:flex;align-items:center;margin-left:40px;margin-top:23px">
                    <div style="display:flex;align-items:center;flex-direction:column">
                      <div class="blue-radius">
                        {{basicInfo.endSugar}}
                      </div>
                      <div style="font-size: 12px;font-weight: 400;color: #009CEE;line-height: 17px;margin-top:13px;margin-bottom:13px">
                        目标<br/>范围
                      </div>
                      <div class="blue-radius">
                        {{basicInfo.startSugar}}
                      </div>
                    </div>
                    <div class="lian-xu" ref="precession_diagram" id="precessionDiagram" ></div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </a-spin>
      </a-tab-pane>
      <a-tab-pane key="2" tab="24小时重叠图" force-render>
        <a-spin :spinning="spinning2" size="large">
          <div ref='tab2' id='tab2' style="padding-left: 25px">
            <div style="display: flex;align-items: center;justify-content: space-between">
              <img src="../assets/img/mq_logo.png" style="width: 120px;height: 38px" />
              <div class="rep-title" style="position:absolute;left:50%;transform:translate(-50%);">动态血糖监测报告</div>
              <div style="display:flex">
                <div>
                  <div style="display: flex;align-items: center">
                    <div class="small-point"></div>
                    <div style="margin-left: 8px" class="info-text">姓名：</div>
                    <div class="info-text-1">{{basicInfo.name || '--'}}</div>
                  </div>
                  <div style="display: flex;align-items: center">
                    <div class="small-point"></div>
                    <div style="margin-left: 8px" class="info-text">年龄：</div>
                    <div class="info-text-1">{{basicInfo.age || '--' }}</div>
                  </div>
                  <div style="display: flex;align-items: center">
                    <div class="small-point"></div>
                    <div style="margin-left: 8px" class="info-text">性别：</div>
                    <div class="info-text-1">{{getSex(basicInfo.sex)}}</div>
                  </div>
                </div>
                <div style="margin-left:50px">
                  <div style="display: flex;align-items: center">
                    <div class="small-point"></div>
                    <div style="margin-left: 8px" class="info-text">监测账号：</div>
                    <div class="info-text-1">{{basicInfo.monitorPhone}}</div>
                  </div>
                  <div style="display: flex;align-items: center">
                    <div class="small-point"></div>
                    <div style="margin-left: 8px" class="info-text">生成时间：</div>
                    <div class="info-text-1">{{getCreateTime}}</div>
                  </div>
                </div>
              </div>

            </div>
            <div class="chart-content update10">
              <div class="chart-title">{{getStartDate}}至{{getEndDate}} {{allDays}}</div>
              <div class="chart-border-2">
                <div class="chart-2">
                  <div style="display:flex;margin-left:40px;margin-top:64px;align-items:center;">
                    <div style="width:5px;height:26px;background-color:#009CEE;">
                    </div>
                    <div class="chart2-title">
                      24小时重叠图
                    </div>
                    <div style="position:absolute;right:60px;">
                      <div style="display:flex;align-items:center">
                        <div v-for="(item,index) in this.dateLine1" :key="index" :style="{marginStart:'50px'}">
                          <div style="font-size: 16px;font-weight: 400;color: #666666;line-height: 22px;">
                            {{item}}
                          </div>
                          <div :style="legendColor(index)">
                          </div>
                        </div>
                      </div>
                      <div style="display:flex;align-items:center">
                        <div v-for="(item,index) in this.dateLine2" :key="index" :style="{marginStart:'50px'}">
                          <div style="font-size: 16px;font-weight: 400;color: #666666;line-height: 22px;">
                            {{item}}
                          </div>
                          <div :style="legendColor(index)">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style="display:flex;align-items:center;margin-left:40px;" class="update5">
                    <div style="display:flex;align-items:center;flex-direction:column">
                      <div class="blue-radius">
                        {{basicInfo.endSugar}}
                      </div>
                      <div class="target">
                        目标<br/>范围
                      </div>
                      <div class="blue-radius">
                        {{basicInfo.startSugar}}
                      </div>
                    </div>
                    <div class="chart24hours" ref="chart24hours" id="chart24hours" ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a-spin>
      </a-tab-pane>
      <a-tab-pane key="3" tab="每日总结" force-render>
        <a-spin :spinning="spinning3" size="large">
          <div>
            <div style="display: flex;align-items: center;justify-content: space-between">
              <img src="../assets/img/mq_logo.png" style="width: 120px;height: 38px" />
              <div class="rep-title" style="position:absolute;left:50%;transform:translate(-50%);">动态血糖监测报告</div>
              <div style="display:flex">
                <div>
                  <div style="display: flex;align-items: center">
                    <div class="small-point"></div>
                    <div style="margin-left: 8px" class="info-text">姓名：</div>
                    <div class="info-text-1">{{basicInfo.name || '--'}}</div>
                  </div>
                  <div style="display: flex;align-items: center">
                    <div class="small-point"></div>
                    <div style="margin-left: 8px" class="info-text">年龄：</div>
                    <div class="info-text-1">{{basicInfo.age || '--' }}</div>
                  </div>
                  <div style="display: flex;align-items: center">
                    <div class="small-point"></div>
                    <div style="margin-left: 8px" class="info-text">性别：</div>
                    <div class="info-text-1">{{getSex(basicInfo.sex)}}</div>
                  </div>
                </div>
                <div style="margin-left:50px">
                  <div style="display: flex;align-items: center">
                    <div class="small-point"></div>
                    <div style="margin-left: 8px" class="info-text">监测账号：</div>
                    <div class="info-text-1">{{basicInfo.monitorPhone}}</div>
                  </div>
                  <div style="display: flex;align-items: center">
                    <div class="small-point"></div>
                    <div style="margin-left: 8px" class="info-text">生成时间：</div>
                    <div class="info-text-1">{{getCreateTime}}</div>
                  </div>
                </div>
              </div>

            </div>
            <div style="height: auto;overflow: scroll" class="chart-content">
              <div class="chart-title">{{getStartDate}}至{{getEndDate}} {{allDays}}</div>
              <div class="chart-border-2" style="padding-bottom:30px">
                <div class="chart-2">
                  <div style="display:flex;margin-left:40px;align-items:center;" class="update3">
                    <div style="width:5px;height:26px;background-color:#009CEE;">
                    </div>
                    <div class="chart2-title">
                      每日总结
                    </div>
                    <div style="display:flex;align-items:center;background-color: rgba(0,156,238,0.05);border-radius: 14px;margin-left:45px;padding:4px 15px;">
                      <img src="../assets/img/mq_can_bi_icon.png" style="width:15px;height:15px;" />
                      <div class="chart2-lengend">
                        参比
                      </div>
                      <img src="../assets/img/mq_eat_icon.png" style="width:15px;height:15px;margin-left:18px" />
                      <div class="chart2-lengend">
                        饮食
                      </div>
                      <img src="../assets/img/mq_medicine_icon.png" style="width:15px;height:15px;margin-left:18px" />
                      <div class="chart2-lengend">
                        用药
                      </div>
                      <img src="../assets/img/mq_work_out_icon.png" style="width:15px;height:15px;margin-left:18px" />
                      <div class="chart2-lengend">
                        锻炼
                      </div>
                    </div>
                  </div>
                  <div v-for="(item,index) in dateLine3" v-bind:key="index" >
                    <div style="display:flex;align-items:center;margin-left:40px;" class="update5">
                      <div>
                        <div class="chart-date">
                          {{item.day}}
                        </div>
                        <div class="dayChart" ref="dayChart" :id="getId(index)" ></div>
                      </div>

                      <div class="table-date">
                        <div class="chart-1-label-data">
                          <div class="chart-number-1">{{item.avgSg}}</div>
                          <div class="chart-unit-1">mmol/L</div>
                          <div class="chart-des-1">血糖平均值</div>
                        </div>
                        <div class="chart-1-label-data update11" >
                          <div class="chart-number-1">{{item.highBlood}}</div>
                          <div class="chart-unit-1">mmol/L</div>
                          <div class="chart-des-1">血糖最高值</div>
                        </div>
                        <div class="chart-1-label-data update11" >
                          <div class="chart-number-1">{{item.lowBlood}}</div>
                          <div class="chart-unit-1">mmol/L</div>
                          <div class="chart-des-1">血糖最低值</div>
                        </div>
                        <div class="chart-1-label-data update11" >
                          <div class="chart-number-1">{{item.highPercent}}</div>
                          <div class="chart-unit-1">%</div>
                          <div class="chart-des-1">高血糖占比</div>
                        </div>
                        <div class="chart-1-label-data update11" >
                          <div class="chart-number-1">{{item.lowPercent}}</div>
                          <div class="chart-unit-1">%</div>
                          <div class="chart-des-1">低血糖占比</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a-spin>
      </a-tab-pane>
      <a-tab-pane key="4" tab="TIR图谱" force-render>
        <a-spin :spinning="spinning4" size="large">
          <div ref='tab4' id='tab4' style="padding-left: 20px">
            <div style="display: flex;align-items: center;justify-content: space-between">
              <img src="../assets/img/mq_logo.png" style="width: 120px;height: 38px" />
              <div class="rep-title" style="position:absolute;left:50%;transform:translate(-50%);">动态血糖监测报告</div>
              <div style="display:flex">
                <div>
                  <div style="display: flex;align-items: center">
                    <div class="small-point"></div>
                    <div style="margin-left: 8px" class="info-text">姓名：</div>
                    <div class="info-text-1">{{basicInfo.name || '--'}}</div>
                  </div>
                  <div style="display: flex;align-items: center">
                    <div class="small-point"></div>
                    <div style="margin-left: 8px" class="info-text">年龄：</div>
                    <div class="info-text-1">{{basicInfo.age || '--' }}</div>
                  </div>
                  <div style="display: flex;align-items: center">
                    <div class="small-point"></div>
                    <div style="margin-left: 8px" class="info-text">性别：</div>
                    <div class="info-text-1">{{getSex(basicInfo.sex)}}</div>
                  </div>
                </div>
                <div style="margin-left:50px">
                  <div style="display: flex;align-items: center">
                    <div class="small-point"></div>
                    <div style="margin-left: 8px" class="info-text">监测账号：</div>
                    <div class="info-text-1">{{basicInfo.monitorPhone}}</div>
                  </div>
                  <div style="display: flex;align-items: center">
                    <div class="small-point"></div>
                    <div style="margin-left: 8px" class="info-text">生成时间：</div>
                    <div class="info-text-1">{{getCreateTime}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div style="height: auto;overflow: scroll" class="chart-content">
              <div class="chart-title">{{getStartDate}}至{{getEndDate}} {{allDays}}</div>
              <div class="chart-border-2">
                <div class="chart-2">
                  <div style="display:flex;margin-left:40px;align-items:center;" class="update3">
                    <div style="width:5px;height:26px;background-color:#009CEE;">
                    </div>
                    <div class="chart2-title">
                      TIR图谱
                    </div>
                  </div>
                  <div class='chartLabel'>
                    <div style='display: flex;flex-direction: column;align-items: center'>
                      <div class="TIR-label">
                        TAR(PT, >13.9 mmol/L)
                      </div>
                      <div style='width: 100%;height: 5px;background-color: #6D57FF;border-radius: 5px;margin-top: 12px'>
                      </div>
                    </div>
                    <div style='display: flex;flex-direction: column;align-items: center;margin-left: 60px'>
                      <div class="TIR-label">
                        TAR(PT, >10.0 mmol/L)
                      </div>
                      <div style='width: 100%;height: 5px;background-color: #3FA3FF;border-radius: 5px;margin-top: 12px'>
                      </div>
                    </div>
                    <div style='display: flex;flex-direction: column;align-items: center;margin-left: 60px'>
                      <div class="TIR-label">
                        TIR（PT，3.9mmol/L-10.0mmol/L)
                      </div>
                      <div style='width: 100%;height: 5px;background-color: #3ACB9E;border-radius: 5px;margin-top: 12px'>
                      </div>
                    </div>
                    <div style='display: flex;flex-direction: column;align-items: center;margin-left: 60px'>
                      <div class="TIR-label">
                        TBR(PT, <3.9 mmol/L)
                      </div>
                      <div style='width: 100%;height: 5px;background-color: #F6BD16;border-radius: 5px;margin-top: 12px'>
                      </div>
                    </div>
                    <div style='display: flex;flex-direction: column;align-items: center;margin-left: 60px'>
                      <div class="TIR-label">
                        TBR(PT, <3.0 mmol/L)
                      </div>
                      <div style='width: 100%;height: 5px;background-color: #F68D16;border-radius: 5px;margin-top: 12px'>
                      </div>
                    </div>
                  </div>
                  <div style="width: auto;" class="TIRChart" ref="TIRChart" id="TIRChart">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a-spin>
      </a-tab-pane>
      <a-tab-pane key="5" tab="打印选择">
        <a-spin :spinning="spinning5" size="large">
          <div>
            <div style="display: flex;align-items: center;justify-content: space-between">
              <img src="../assets/img/mq_logo.png" style="width: 120px;height: 38px" />
              <div class="rep-title" style="position:absolute;left:50%;transform:translate(-50%);">动态血糖监测报告</div>
              <div style="display:flex">
                <div>
                  <div style="display: flex;align-items: center">
                    <div class="small-point"></div>
                    <div style="margin-left: 8px" class="info-text">姓名：</div>
                    <div class="info-text-1">{{basicInfo.name || '--'}}</div>
                  </div>
                  <div style="display: flex;align-items: center">
                    <div class="small-point"></div>
                    <div style="margin-left: 8px" class="info-text">年龄：</div>
                    <div class="info-text-1">{{basicInfo.age || '--' }}</div>
                  </div>
                  <div style="display: flex;align-items: center">
                    <div class="small-point"></div>
                    <div style="margin-left: 8px" class="info-text">性别：</div>
                    <div class="info-text-1">{{getSex(basicInfo.sex)}}</div>
                  </div>
                </div>
                <div style="margin-left:50px">
                  <div style="display: flex;align-items: center">
                    <div class="small-point"></div>
                    <div style="margin-left: 8px" class="info-text">监测账号：</div>
                    <div class="info-text-1">{{basicInfo.monitorPhone}}</div>
                  </div>
                  <div style="display: flex;align-items: center">
                    <div class="small-point"></div>
                    <div style="margin-left: 8px" class="info-text">生成时间：</div>
                    <div class="info-text-1">{{getCreateTime}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="chart-content update8">
              <div class="chart-title">{{getStartDate}}至{{getEndDate}} {{allDays}}</div>
              <div class="chart-border-2">
                <div class="chart-2">
                  <div style="display:flex;align-items:center;" class="update9">
                    <div style="width:5px;height:26px;background-color:#009CEE;">
                    </div>
                    <div class="chart2-title">
                      选择下载打印
                    </div>
                  </div>
                </div>
                <div class="table-day">
                  <div  class="table-title choose">
                    选择
                  </div>
                  <div  class="table-title date-date">
                    日期
                  </div>
                  <div  class="table-title wear-time">
                    佩戴时长
                  </div>
                  <div  class="table-title high-percent">
                    高血糖占比
                  </div>
                  <div  class="table-title low-percent">
                    低血糖占比
                  </div>
                  <div  class="table-title date-date">
                    操作
                  </div>
                </div>
                <div class="print-table">
                  <div v-for="(item ,index) in dateLine3" :key="index">
                    <div :style="tableLine(index)" class="ADTTT">
                      <div class="table-number choose">
                        <input type="checkbox" v-model="printSelect[index]"  @click='checkClick(index)' :value='item'/>
                      </div>
                      <div class="table-number date-date">
                        {{item.day}}
                      </div>
                      <div class="table-number wear-time">
                        {{item.wearTime}}
                      </div>
                      <div  class="table-number high-percent">
                        {{item.highPercent}}%
                      </div>
                      <div  class="table-number low-percent">
                        {{item.lowPercent}}%
                      </div>
                      <div  style="cursor: pointer" class="table-number-print date-date" @click="showPreView(item)">
                        打印报告
                      </div>
                    </div>
                  </div>
                </div>
                <div class="print-options">
                  <input type="checkBox" @change='allSelect'/>
                  <div class="select-all" >全选</div>
                  <div v-bind:class="btnState1" @click='createReport'>
                    生成报告
                  </div>
                  <div v-bind:class="btnState" style="margin-left:30px" @click='printAllPages'>
                    批量打印
                  </div>
                  <div v-bind:class="btnState" style="margin-left:30px" @click='downloadPDF'>
                    PDF下载
                  </div>
                  <div style='margin-left: 50px;'>
                    第一次打印请点击下载并安装以下两个打印插件(
                  </div>
                  <a href='./static/CLodop_Setup_for_Win32NT.exe' download='CLodop_Setup_for_Win32NT.exe' style='margin-left: 20px;text-decoration:underline'>1.CLodop_Setup_for_Win32NT.exe</a>
                  <a href='./static/install_lodop64.exe' download='install_lodop64.exe' style='margin-left: 50px;text-decoration:underline'>2.install_lodop64.exe</a>
                  <div style='margin-left: 20px;'>
                    )
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a-spin>
      </a-tab-pane>
      <a-tab-pane key='6' tab='数据表格' force-render>
        <div id="tab6" ref='tab6'>
          <a-table
            :style="{'height':'100%'}"
            :columns="metricsColumns"
            :pagination="false"
            :dataSource="metricsData"
            :scroll="tableSize"
            :loading="metricsLoading">
          </a-table>
        </div>
      </a-tab-pane>
    </a-tabs>
  </a-modal>
</template>

<script>
import moment from 'moment'
import html2canvas from 'html2canvas'
import Vue from 'vue'
import JsPDF from 'jspdf'
import {postAction} from '../network/GetAndPost'
import {getLodop} from '../assets/js/LodopFuncs'
export default {
  name: 'Report',
  data() {
    return {
      ModalText: 'Content of the modal',

      metricsColumns:[],
      metricsData:[],
      tableSize:{
      },
      metricsLoading:true,
      scrollbarStyle:{
        height: "1050px",
        overflow: 'scroll',
        marginTop: "32px",
      },
      generalUrl:"/index/snapshot/general",
      sequenceMap:"/index/snapshot/sequenceMap",
      sequenceWeekMap:'/index/snapshot/sequenceDayMap',
      sequenceDayMap:'/index/snapshot/sequenceDayMap',
      tir:'/index/snapshot/tir',
      selectAll:false,
      visible: false,
      confirmLoading: true,
      tabKey: '1',
      basicInfo:{},
      duration:'',
      bodyStyle: { top: '10px' },
      markPointData:[],
      chartData:[],
      colors:["#009cee","#3cd1a6","#d83fff","#5e71ff","#ff5e5e","#ff923f","#80069f","#267861","#992626","#534155","#949b1b","#03a104","#0b3c99","#b56324","#030b2e"],
      printSelect:[],
      dateLine1:[],
      dateLine2:[],
      dateLine3:[],
      seriesData:[],
      TIRs:[],
      printDay:[],
      record:{},

      dayImgUrl:[],
      nag:true,
      spinning1:true,
      spinning2:true,
      spinning3:true,
      spinning4:true,
      spinning5:true,
      delayTime:500,
      state:true
    }
  },
  computed:{
    btnState1:function(){
      return {
        'button-enable': this.state,
        'button-disable': !this.state
      }
    },
    btnState:function(){
      return {
        'button-enable': !this.state,
        'button-disable': this.state
      }
    },
    getCreateTime:function(){
      return moment().format('YYYY-MM-DD HH:mm:ss');
    },
    getStartDate:function(){
      if(this.basicInfo.startDate == null){
        return "暂无"
      }else {
        return this.basicInfo.startDate.substr(0,10)
      }
    },
    getEndDate:function(){
      if(this.basicInfo.endDate == null){
        return moment().format("YYYY-MM-DD")
      }else {
        return this.basicInfo.endDate.substr(0,10)
      }
    },
    allDays:function(){
      if(this.basicInfo.endDate == null){
        return "佩戴中"
      }else {

        return "共"+this.dateLine3.length+"天"
      }
    }
  },
  methods: {

    handleCancel(e) {
      console.log('Clicked cancel button');
      this.visible = false;
    },
    getSex:function(sex){
      if(sex === '1' || sex === 1){
        return '男'
      }else if(sex === '2' || sex === 2){
        return '女'
      }else {
        return '--'
      }
    },
    setUrl:function(url){
      this.dayImgUrl.push(url)
      if(this.dayImgUrl.length === this.dateLine3.length && this.dayImgUrl!==0){
        this.spinning5 = false;
        this.state = false
      }
    },
    createReport:function(){
      if(this.state){
        this.spinning5 = true
        setTimeout(this.theMostImportantHandle,1000)
      }
    },
    downloadPDF:function(){
      let imgUrl1,imgUrl2,imgUrl3,imgUrl4
      let that = this
      let PDF = new JsPDF('p', 'pt', 'a4')
      window.pageYoffset = 0;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      this.spinning5 = true

      html2canvas(this.$refs.tab1).then(canvas => {
        // 转成图片，生成图片地址
        imgUrl1 = canvas.toDataURL("image/jpg");
        PDF.addImage(imgUrl1, 'JPEG', 50, 20, 500, 360)
        html2canvas(that.$refs.tab2).then(canvas1=>{
          imgUrl2 = canvas1.toDataURL("image/jpg")
          PDF.addImage(imgUrl2, 'JPEG', 50, 430, 500, 360)

          html2canvas(that.$refs.tab6).then(canvas3=>{
            imgUrl4 = canvas3.toDataURL("image/jpg")
            PDF.addPage("a4","l");
            PDF.addImage(imgUrl4, 'JPEG', 20, 20, 800, 500)
            html2canvas(that.$refs.tab4).then(canvas2 =>{
              imgUrl3 = canvas2.toDataURL("image/jpg")
              PDF.addPage("a4","p");
              PDF.addImage(imgUrl3, 'JPEG', 50, 20, 500, 360)
              let a = 1
              for(let i = 0;i<this.printSelect.length;i++){
                if(that.printSelect[i]){
                  let imgUrl4 = that.dayImgUrl[i]
                  let y
                  if(a%2 === 0){
                    PDF.addPage("a4","p");
                    y = 20
                  }else {
                    y = 430
                  }
                  PDF.addImage(imgUrl4,'JPEG',50,y,500,360)
                  a++
                }
              }
              this.spinning5 = false
              PDF.save(this.basicInfo.name+this.basicInfo.startDate)
            })
          })


        })

      });
    },
    printAllPages:function() {

      let imgUrl1,imgUrl2,imgUrl3,imgUrl5
      let that = this
      window.pageYoffset = 0;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      html2canvas(this.$refs.tab1).then(canvas => {
        // 转成图片，生成图片地址
        imgUrl1 = canvas.toDataURL("image/png");
        //that.downloadFile("test.png",imgUrl1)
        html2canvas(that.$refs.tab2).then(canvas1=>{
          imgUrl2 = canvas1.toDataURL("image/png")
          html2canvas(that.$refs.tab4).then(canvas2 =>{
            imgUrl3 = canvas2.toDataURL("image/png")
            html2canvas(that.$refs.tab6).then(canvas3 => {
              imgUrl5 = canvas3.toDataURL("image/png")
              let LODOP = getLodop();
              LODOP.PRINT_INIT("打印控件功能演示_Lodop功能_表单一");
              //ADD_PRINT_IMAGE(top,left,width,height,strHtmlContent)
              LODOP.ADD_PRINT_IMAGE(60, 100, 866, 750, "<img  border='0' src='" + imgUrl1 + "' />");
              LODOP.SET_PRINT_STYLEA(0, "Stretch", 1)
              LODOP.NEWPAGE();
              LODOP.ADD_PRINT_IMAGE(60, 100, 866, 600, "<img  border='0' src='" + imgUrl2 + "' />");
              LODOP.SET_PRINT_STYLEA(0, "Stretch", 1)
              LODOP.NEWPAGE();
              LODOP.ADD_PRINT_IMAGE(60, 100, 866, 600, "<img  border='0' src='" + imgUrl3 + "' />");
              LODOP.SET_PRINT_STYLEA(0, "Stretch", 1)
              LODOP.NEWPAGE();
              LODOP.ADD_PRINT_IMAGE(60, 100, 866, 600, "<img  border='0' src='" + imgUrl5 + "' />");
              LODOP.SET_PRINT_STYLEA(0, "Stretch", 1)
              for (let i = 0; i < this.printSelect.length; i++) {

                if (that.printSelect[i]) {
                  LODOP.NEWPAGE();
                  let imgUrl4 = that.dayImgUrl[i]

                  LODOP.ADD_PRINT_IMAGE(60, 100, 866, 600, "<img  border='0' src='" + imgUrl4 + "' />");
                  LODOP.SET_PRINT_STYLEA(0, "Stretch", 1)
                }

              }

              // LODOP.PRINT_DESIGN();
              LODOP.PREVIEW();
            })
          })
        })
      });
    },
    //下载
    downloadFile(fileName, content) {
      let aLink = document.createElement('a');
      let blob = this.base64ToBlob(content); //new Blob([content]);

      let evt = document.createEvent("HTMLEvents");
      evt.initEvent("click", true, true);//initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
      aLink.download = fileName;
      aLink.href = URL.createObjectURL(blob);

      // aLink.dispatchEvent(evt);
      aLink.click()
    },
    //base64转blob
    base64ToBlob(code) {
      let parts = code.split(';base64,');
      let contentType = parts[0].split(':')[1];
      let raw = window.atob(parts[1]);
      let rawLength = raw.length;

      let uInt8Array = new Uint8Array(rawLength);

      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      return new Blob([uInt8Array], {type: contentType});
    },
    allSelect:function(){
      this.selectAll = !this.selectAll
      if(this.selectAll){
        for(let i=0;i<this.printSelect.length;i++){
          Vue.set(this.printSelect,i,true)
        }
      }else {
        for(let i=0;i<this.printSelect.length;i++){
          Vue.set(this.printSelect,i,false)
        }
      }
    },
    checkClick:function(index){
      this.printSelect[index] = !this.printSelect[index]
    },
    getId:function(index){
      return "dayChart"+index;
    },
    showPreView:function(item){
      this.$emit('preViewShow',item,this.basicInfo)
    },
    legendColor:function(index){
      let a = {
        height:"3px",
        width:"38px",
        marginTop:"5px",
      };
      a.backgroundColor = this.colors[index];
      return a;
    },
    tableLine:function(index){
      let a = {
        display:'flex',
        height:"52px",
        width:'fit-content'
      };
      if(index%2 === 0){
        a.backgroundColor = "#FFFFFF"
      }else{
        a.backgroundColor = "#F9F9F9"
      }
      return a;
    },
    view: function (record) {
      this.state=true
      this.spinning1=true
      this.spinning2=true
      this.spinning3=true
      this.spinning4=true
      this.spinning5=true
      this.selectAll = false
      this.dayImgUrl = []
      this.printSelect = []
      this.record = record
      this.visible = true
      this.metricsLoading = true
      this.dateLine3 = []
      this.metricsColumns = [];
      this.metricsColumns.push({
          title:"",
          dataIndex: 'metricsName',
          width: '10%',
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '总体',
          dataIndex: '总体',
          width:'5%'
        });
      this.metricsData = [
        {
          metricsName: '血糖标准差(SD)'
        },
        {
          metricsName: '有效波动平均幅度(MAGE,mmol/L)'
        },
        {
          metricsName: '血糖平均值(MG,mmol/L)'
        },
        {
          metricsName: '空腹平均血糖(mmol/L)'
        },
        {
          metricsName: '餐后平均值(早)(mmol/L)'
        },
        {
          metricsName: '餐后平均值(中)(mmol/L)'
        },
        {
          metricsName: '餐后平均值(晚)(mmol/L)'
        },
        {
          metricsName: '血糖百分比(PT,<3.9 mmol/L)'
        },
        {
          metricsName: '血糖百分比(PT,>7.8 mmol/L)'
        },
        {
          metricsName: '血糖百分比(PT,>11.1 mmol/L)'
        },
        {
          metricsName: '曲线-时间面积(AUC,>10 mmol*h/L)'
        },
        {
          metricsName: '曲线-时间面积(AUC,<3.9 mmol*h/L)'
        },
        {
          metricsName: '血糖最大波动幅度(LAGE,mmol/L)'
        },
        {
          metricsName: 'TIR(PT,>3.9 mmol/L,<10 mmol/L)'
        }
      ];
      let that = this
      let params = new FormData();
      this.nag = true
      params.append("snapshotId",record.id);
      postAction(this.generalUrl,params).then((res)=>{
        if(res.status === 200){
          that.basicInfo = res.result;
          that.$nextTick(() => {
            let line_dv = document.getElementById('myChart')
            let myChart = this.$echarts.init(line_dv)

            let option = {
              animation:false,
              title: {
                text: '血糖值时间比例',
                bottom: 0,
                left: 'center',
                right: 'center',
                textStyle: {
                  color: '#666666',
                  fontSize: 18,
                  fontWeight: 400,
                },
              },
              angleAxis: {
                max: 100,
                clockwise: true, // 逆时针
                // 隐藏刻度线
                show: false,
              },
              legend: {
                top: 50,
                show: true,
                orient: 'horizontal',
                itemGap: 17,
                itemWidth: 10,
                itemHeight: 10,
                data: [
                  {
                    name: '正常('+that.basicInfo.startSugar+'-'+that.basicInfo.endSugar+')',
                    // 强制设置图形为圆。
                    icon: 'circle',
                    // 设置文本为红色
                    itemStyle: {
                      color: '#009CEE',
                    },
                    textStyle: {
                      color: '#666666',
                      fontSize: 15,
                    },
                  },
                  {
                    name: '低于'+that.basicInfo.startSugar,
                    // 强制设置图形为圆。
                    icon: 'circle',
                    // 设置文本为红色
                    itemStyle: {
                      color: '#F7DC61',
                    },
                    textStyle: {
                      color: '#666666',
                      fontSize: 15,
                    },
                  },
                  {
                    name: '高于'+that.basicInfo.endSugar,
                    // 强制设置图形为圆。
                    icon: 'circle',
                    // 设置文本为红色
                    itemStyle: {
                      color: '#FF5E5E',
                    },
                    textStyle: {
                      color: '#666666',
                      fontSize: 15,
                    },
                  },
                ],
              },
              radiusAxis: {
                type: 'category',
                show: true,
                axisLabel: {
                  show: false,
                },
                axisLine: {
                  show: false,
                },
                axisTick: {
                  show: false,
                },
              },
              polar: {
                center: ['50%', '60%'],
                radius: '100%', //图形大小
              },
              series: [
                {
                  name: '正常('+that.basicInfo.startSugar+'-'+that.basicInfo.endSugar+')',
                  type: 'bar',
                  data: [that.basicInfo.normalPercent],
                  coordinateSystem: 'polar',
                  roundCap: true,
                  barWidth: 30,
                  itemStyle: {
                    normal: {
                      color: '#009CEE',
                    },
                  },
                  stack: 'a',
                },
                {
                  name: '低于'+that.basicInfo.startSugar,
                  type: 'bar',
                  data: [that.basicInfo.lowPercent],
                  coordinateSystem: 'polar',
                  roundCap: true,
                  barWidth: 30,
                  itemStyle: {
                    normal: {
                      color: '#F7DC61',
                    },
                  },
                  stack: 'a',
                },
                {
                  name: '高于'+that.basicInfo.endSugar,
                  type: 'bar',
                  data: [that.basicInfo.highPercent],
                  coordinateSystem: 'polar',
                  roundCap: true,
                  barWidth: 30,
                  itemStyle: {
                    normal: {
                      color: '#FF5E5E',
                    },
                  },
                  stack: 'a',
                },
              ],
            }

            myChart.setOption(option)

            let precession = document.getElementById('precessionDiagram')
            let pd = this.$echarts.init(precession)
            postAction(that.sequenceMap,params).then((res)=>{
              that.spinning1 = false
              if(res.status === 200){
                that.chartData = [];
                that.markPointData = [];

                let a = res.result.rawDataBagsChartVOList
                let index = 0
                for(let i = 0;i<a.length;i++){
                  if(a[i].machineBloodSugar>0){
                    index = i
                    break
                  }
                }
                res.result.rawDataBagsChartVOList.splice(0,index)

                for(let i = 0;i<res.result.rawDataBagsChartVOList.length;i++){
                  let x = res.result.rawDataBagsChartVOList[i].recordDate;
                  let y = res.result.rawDataBagsChartVOList[i].machineBloodSugar;
                  let data = [x,y];
                  that.chartData.push(data);

                  if(res.result.rawDataBagsChartVOList[i].eventList.length>0){
                    for(let j = 0;j < res.result.rawDataBagsChartVOList[i].eventList.length;j++){
                      if(res.result.rawDataBagsChartVOList[i].eventList[j].event_type === 1){
                        let patientEvent = [res.result.rawDataBagsChartVOList[i].recordDate,res.result.rawDataBagsChartVOList[i].machineBloodSugar];
                        let markPointGlucoseData = {
                          coord:patientEvent,
                          symbol: 'image://' + require('../assets/img/mq_can_bi_icon.svg'),
                          symbolSize:'18'
                        };
                        that.markPointData.push(markPointGlucoseData);
                      }else if(res.result.rawDataBagsChartVOList[i].eventList[j].event_type === 2){
                        let patientEvent = [res.result.rawDataBagsChartVOList[i].recordDate,res.result.rawDataBagsChartVOList[i].machineBloodSugar];
                        let markPointEatFoodData = {
                          coord:patientEvent,
                          symbol: 'image://' + require('../assets/img/mq_eat_icon.svg'),
                          symbolSize:'18'
                        };
                        that.markPointData.push(markPointEatFoodData);
                      }else if(res.result.rawDataBagsChartVOList[i].eventList[j].event_type === 3){
                        let patientEvent = [res.result.rawDataBagsChartVOList[i].recordDate,res.result.rawDataBagsChartVOList[i].machineBloodSugar];
                        let markPointMedicineData = {
                          coord:patientEvent,
                          symbol: 'image://' + require('../assets/img/mq_medicine_icon.svg'),
                          symbolSize:'18'
                        };
                        that.markPointData.push(markPointMedicineData);
                      }else if(res.result.rawDataBagsChartVOList[i].eventList[j].event_type === 4){
                        let patientEvent = [res.result.rawDataBagsChartVOList[i].recordDate,res.result.rawDataBagsChartVOList[i].machineBloodSugar];
                        let markPointInsulinData = {
                          coord:patientEvent,
                          symbol: 'image://' + require('../assets/img/mq_insulin_icon.svg'),
                          symbolSize:'18'
                        };
                        that.markPointData.push(markPointInsulinData);
                      }else if(res.result.rawDataBagsChartVOList[i].eventList[j].event_type === 5){
                        let patientEvent = [res.result.rawDataBagsChartVOList[i].recordDate,res.result.rawDataBagsChartVOList[i].machineBloodSugar];
                        let markPointWorkOutData = {
                          coord:patientEvent,
                          symbol: 'image://' + require('../assets/img/mq_work_out_icon.svg'),
                          symbolSize:'18'
                        };
                        that.markPointData.push(markPointWorkOutData);
                      }

                    }
                  }

                }

                let pdtion = {
                  grid:{
                    top:40,
                    left:40,
                    right:60
                  },
                  animation: false,
                  tooltip: {
                    trigger: 'axis',
                    formatter(params) {
                      if(params[0].data.length>1){
                        return `${params[0].data[1]} mmol/L<br/>${params[0].data[0]}`;
                      }
                    },
                    show:true,
                    showContent:true
                  },
                  toolbox:{
                    feature:{
                      dataZoom:{
                        yAxisIndex: 'none'
                      }
                    }
                  },
                  dataZoom: [{
                    type: 'inside',
                    start: 0,
                    end: 100
                  }, {
                    start: 0,
                    end: 100
                  }],
                  xAxis: {
                    type: 'time',
                    axisLabel:{
                      formatter: function (value,index) {
                        // 格式化成月/日
                        let date = new Date(value);
                        if (date.getHours() === 0){
                          return '{gray|'+(date.getMonth()+1)+'-'+date.getDate()+'}';
                        }
                      },
                      rich:{
                        gray: {
                          color: '#999999',
                          fontSize: 12
                        },
                        blue:{
                          color:'#1790FF',
                          fontSize: 14,
                          height:24,
                          backgroundColor: 'rgba(23,144,255,0.05)',
                          borderRadius: 5,
                          padding:[0,10,2,10],
                        }
                      },
                      textStyle:{
                        color:'rgba(23,114,255,1)'
                      },
                    },
                    axisTick:{
                      show:true
                    },
                    axisLine:{
                      show:true
                    },
                    interval:3600*1000,
                    z:2
                  },
                  yAxis:{
                    name:"mmol/L",
                    type: 'value',
                    axisTick:{
                      show:true,
                      interval:5,
                    },
                    minorTick:{
                      show:true,
                      splitNumber :2
                    },
                    max:Math.ceil(that.basicInfo.highBlood*1.5),
                    min:0,
                    show: true,
                    zlevel:2,
                    axisLabel:{
                      show:true
                    },
                    splitLine:{
                      show:false
                    },
                    axisLine:{
                      show:true,
                      lineStyle:{
                        color:"#999999"
                      }
                    }
                  },
                  series:[

                    {
                      name: '血糖',
                      type: 'line',
                      data: this.chartData,
                      symbol:'none',
                      itemStyle : {
                        normal: {
                          lineStyle: {
                            color: 'rgba(23,114,255,1)'
                          }
                        }
                      },
                      markPoint:{
                        symbolSize:30,
                        data:this.markPointData,
                        itemStyle:{
                          color:'#FF5E5E'
                        }
                      },
                      markArea:{
                        data: [[{
                          yAxis:this.basicInfo.startSugar
                        }, {
                          yAxis:this.basicInfo.endSugar
                        }]],
                        itemStyle:{
                          color:'#F5FCFF',
                        },
                        silent:true,
                      }
                    },
                  ]
                }
                pd.setOption(pdtion)
              }else{
                console.log(res.message)
              }
            })
          })

          this.showChart2();
          this.showChart3();
          this.showChart4();

        }else{
          that.$message.error("请求异常："+res.message)
        }
      });
    },

    showChart2:function(){
      let that = this
      let params = new FormData();
      params.append("snapshotId",this.record.id);
      postAction(this.sequenceWeekMap,params).then((res)=>{
        that.spinning2 = false
        if(res.status === 200){
          that.dateLine1 = []
          that.dateLine2 = []
          that.seriesData = []
          let demo = [];
          for(let x = 0;x<=480;x++){
            let recordDate = x*3*60*1000-28800000;
            demo.push([recordDate,0])
          }

          that.seriesData.push({
            type: 'line',
            data: demo,
            symbol:'none',
            itemStyle : {
              normal: {
                lineStyle: {
                  color: 'rgba(23,114,255,0)'
                }
              }
            }
          })
          if(res.result.sequenceDayDataList.length<9){
            for(let i = 0;i<res.result.sequenceDayDataList.length;i++){
              that.dateLine1.push(res.result.sequenceDayDataList[i].day.slice(5,10))

              let a = [];
              for(let j = 0;j<res.result.sequenceDayDataList[i].rawDataBagsChartVOList.length;j++){
                let rec = res.result.sequenceDayDataList[i].rawDataBagsChartVOList[j].recordDate;
                let ax = moment(rec).hour()*3600000+moment(rec).minutes()*60000+moment(rec).second()*1000-28800000;
                a.push([ax,res.result.sequenceDayDataList[i].rawDataBagsChartVOList[j].machineBloodSugar])
              }
              that.seriesData.push({
                type: 'line',
                data: a,
                symbol:'none',
                itemStyle : {
                  normal: {
                    lineStyle: {
                      color: that.colors[i]
                    }
                  }
                }
              })
            }
          }
          else{
            for(let i = 0;i<8;i++){
              that.dateLine1.push(res.result.sequenceDayDataList[i].day.slice(5,10))

              let a = [];
              for(let j = 0;j<res.result.sequenceDayDataList[i].rawDataBagsChartVOList.length;j++){
                let rec = res.result.sequenceDayDataList[i].rawDataBagsChartVOList[j].recordDate;
                let ax = moment(rec).hour()*3600000+moment(rec).minutes()*60000+moment(rec).second()*1000-28800000;
                a.push([ax,res.result.sequenceDayDataList[i].rawDataBagsChartVOList[j].machineBloodSugar])
              }
              that.seriesData.push({
                type: 'line',
                data: a,
                symbol:'none',
                itemStyle : {
                  normal: {
                    lineStyle: {
                      color: that.colors[i]
                    }
                  }
                }
              })
            }
            for(let i = 8;i<res.result.sequenceDayDataList.length;i++){
              that.dateLine2.push(res.result.sequenceDayDataList[i].day.slice(5,10))

              let a = [];
              for(let j = 0;j<res.result.sequenceDayDataList[i].rawDataBagsChartVOList.length;j++){
                let rec = res.result.sequenceDayDataList[i].rawDataBagsChartVOList[j].recordDate;
                let ax = moment(rec).hour()*3600000+moment(rec).minutes()*60000+moment(rec).second()*1000-28800000;
                a.push([ax,res.result.sequenceDayDataList[i].rawDataBagsChartVOList[j].machineBloodSugar])
              }
              that.seriesData.push({
                type: 'line',
                data: a,
                symbol:'none',
                itemStyle : {
                  normal: {
                    lineStyle: {
                      color: that.colors[i]
                    }
                  }
                }
              })
            }
          }

          let pdtion = {
            grid:{
              top:40,
              left:40,
              right:60
            },
            animation: false,
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross'
              },
              formatter(params) {
                // console.log(params);
                const item = params[params.length-1];
                if (item.data.value.length > 1) {
                  return `${item.data.name}<br/>${item.data.value[1]} mmol/L`;
                }
              },
              show:false
            },
            xAxis: {
              type: 'time',
              axisLabel:{
                formatter: function (value,index) {

                  let d = new Date(value);
                  if(d.getHours()%3===0){
                    return '{gray|'+d.getHours()+':00}';
                  }
                },
                rich:{
                  gray: {
                    color: '#333333',
                    fontSize: 15
                  },
                  blue:{
                    color:'#1790FF',
                    fontSize: 14,
                    height:24,
                    backgroundColor: 'rgba(23,144,255,0.05)',
                    borderRadius: 5,
                    padding:[0,10,2,10],
                  }
                },
                textStyle:{
                  color:'rgba(23,114,255,1)'
                },
              },
              axisTick:{
                show:false
              },
              axisLine:{
                show:true
              },
              splitLine: {
                show:false,
                lineStyle: {
                  color: ['rgba(255,23,23,0.18)','rgba(255,23,23,0)','rgba(255,23,23,0)','rgba(255,23,23,0)','rgba(255,23,23,0)','rgba(255,23,23,0)','rgba(255,23,23,0)','rgba(255,23,23,0)'],
                  type: 'solid'
                },
              },
              splitNumber:12,
              z:2
            },
            yAxis:{
              name:"mmol/L",
              type: 'value',
              axisTick:{
                show:true,
                interval:5,
              },
              minorTick:{
                show:true,
                splitNumber :2
              },
              max:Math.ceil(that.basicInfo.highBlood*1.5),
              min:0,
              show: true,
              axisLabel:{
                show:true
              },
              splitLine:{
                show:false
              },
              axisLine:{
                show:true,
                lineStyle:{
                  color:"#999999"
                }
              }
            },
            series:that.seriesData
          }
          console.log(that.seriesData)
          that.$nextTick(() => {
            let line_dv = document.getElementById('chart24hours')
            let chart24hours = this.$echarts.init(line_dv)

            chart24hours.setOption(pdtion)
          })
        }
      })
    },
    showChart3:function(){
      let that = this
      let params = new FormData();
      params.append("snapshotId",this.record.id);
      that.dateLine3 = [];
      that.printSelect = [];
      postAction(that.sequenceDayMap,params).then((res)=>{
        that.spinning3 = false
        if(res.status === 200){
          that.dateLine3 = res.result.sequenceDayDataList;
          for(let i = 0;i < that.dateLine3.length;i++){
            that.printSelect.push(false)
            that.handleDayChart("dayChart"+i,that.dateLine3[i].rawDataBagsChartVOList)
          }
        }else {
          that.$message.error("请求异常："+res.message)
        }
      })
    },

    theMostImportantHandle:function(){
      for(let i = 0;i < this.dateLine3.length;i++){
        if(this.nag){
          this.$emit("getDayPhoto",this.dateLine3[i],this.basicInfo,i)
        }
      }
      this.nag = false
    },
    showChart6:function(){
      let url = "/index/snapshot/viewSnapshotMetrics"
      let that = this
      let params = new FormData();
      params.append("snapshotId",this.record.id);
      postAction(url,params).then((res) => {
        that.metricsLoading = false
        if(res.status === 200){
          let d = res.result;
          for(let i = 0 ; i < d.length ; i++){
            Vue.set( that.metricsData[2], d[i].day, d[i].avgBloodSugar);
            Vue.set( that.metricsData[7], d[i].day, d[i].percent39 + '%');
            Vue.set( that.metricsData[8], d[i].day, d[i].percent78 + '%');
            Vue.set( that.metricsData[9], d[i].day, d[i].percent111 + '%');
            Vue.set( that.metricsData[13], d[i].day, d[i].percentTir + '%');
            Vue.set( that.metricsData[10], d[i].day, d[i].uprCurveArea10);
            Vue.set( that.metricsData[11], d[i].day, d[i].downCurveArea39);
            Vue.set( that.metricsData[3], d[i].day, d[i].avgBeforeBreakfastSg);
            Vue.set( that.metricsData[4], d[i].day, d[i].avgAfterBreakfastSg);
            Vue.set( that.metricsData[5], d[i].day, d[i].avgAfterLunchSg);
            Vue.set( that.metricsData[6], d[i].day, d[i].avgAfterDinnerSg);
            Vue.set( that.metricsData[0], d[i].day, d[i].sdBloodSugar);
            Vue.set( that.metricsData[12], d[i].day, d[i].waveRange);
            Vue.set( that.metricsData[1], d[i].day, d[i].avgEffectWaveRange);

            if(d[i].day !== '总体'){
              that.metricsColumns.push({
                title: d[i].day.slice(5),
                dataIndex: d[i].day,
                width:'5%'
              })
            }
          }
        }
      }).catch((err) => {
        that.$message.error("请求异常："+err)
      })
    },
    showChart5:function(){
      let that = this
      let params = new FormData();
      params.append("snapshotId",this.record.id);
      that.dateLine3 = [];
      that.printSelect = [];
      postAction(that.sequenceDayMap,params).then((res)=>{
        that.spinning3 = false
        that.spinning5 = false
        if(res.status === 200){
          that.dateLine3 = res.result.sequenceDayDataList;
          for(let i = 0;i < that.dateLine3.length;i++){
            that.printSelect.push(false)
            that.handleDayChart("dayChart"+i,that.dateLine3[i].rawDataBagsChartVOList)
          }
        }else {
          that.$message.error("请求异常："+res.message)
        }
      })
    },

    showChart4:function(){
      let that = this
      let params = new FormData();
      params.append("snapshotId",this.record.id);
      postAction(that.tir,params).then((res)=>{
        that.spinning4 = false
        if(res.status === 200){
          that.TIRs = res.result;
          if(that.TIRs.length>0){
            that.handleTIRData();
          }
        }else {
          that.$message.error("请求异常："+res.message)
        }
      })
    },
    chartChange: function (activeKey) {
      this.tabKey = activeKey
      if(activeKey === '2'){
        if(this.spinning2){
          this.showChart2();
        }
      }
      else if(activeKey === '4'){
        if(this.spinning4){
          this.showChart4();
        }
      }
      else if(activeKey === '3'){
        if(this.spinning3){
          this.showChart3();
        }
      }else if(activeKey === '5'){
        if(this.spinning2){
          this.showChart2()
        }
        if(this.spinning4){
          this.showChart4()
        }
        if(this.spinning3){
          this.showChart5();
        }else {
          this.spinning5 = false
        }

        if(this.metricsLoading){
          this.showChart6();
        }
      }else if(activeKey === '6'){
        if(this.metricsLoading){
          this.showChart6();
        }
      }
    },

    handleDayChart(divId,data){
      let that = this
      let chartDataDay = []
      let markPointDataDay = []
      console.log(data)
      for(let i = 0;i<data.length;i++){
        if(data[i].eventList.length > 0){
          console.log("youshuju")
          console.log(i)
          console.log(data[i])
        }
        chartDataDay.push([data[i].recordDate,data[i].machineBloodSugar])

        if(data[i].eventList.length>0){
          for(let j = 0;j < data[i].eventList.length;j++){
            if(data[i].eventList[j].event_type === 1){
              let patientEvent = [data[i].recordDate,data[i].machineBloodSugar];
              let markPointGlucoseData = {
                coord:patientEvent,
                symbol: 'image://' + require('../assets/img/mq_can_bi_icon.svg'),
                symbolSize:'14'
              };
              markPointDataDay.push(markPointGlucoseData);
            }else if(data[i].eventList[j].event_type === 2){
              let patientEvent = [data[i].recordDate,data[i].machineBloodSugar];
              let markPointEatFoodData = {
                coord:patientEvent,
                symbol: 'image://' + require('../assets/img/mq_eat_icon.svg'),
                symbolSize:'14'
              };
              markPointDataDay.push(markPointEatFoodData);
            }else if(data[i].eventList[j].event_type === 3){
              let patientEvent = [data[i].recordDate,data[i].machineBloodSugar];
              let markPointMedicineData = {
                coord:patientEvent,
                symbol: 'image://' + require('../assets/img/mq_medicine_icon.svg'),
                symbolSize:'14'
              };
              markPointDataDay.push(markPointMedicineData);
            }else if(data[i].eventList[j].event_type === 4){
              let patientEvent = [data[i].recordDate,data[i].machineBloodSugar];
              let markPointInsulinData = {
                coord:patientEvent,
                symbol: 'image://' + require('../assets/img/mq_insulin_icon.svg'),
                symbolSize:'14'
              };
              markPointDataDay.push(markPointInsulinData);
            }else if(data[i].eventList[j].event_type === 5){
              let patientEvent = [data[i].recordDate,data[i].machineBloodSugar];
              let markPointWorkOutData = {
                coord:patientEvent,
                symbol: 'image://' + require('../assets/img/mq_work_out_icon.svg'),
                symbolSize:'14'
              };
              markPointDataDay.push(markPointWorkOutData);
            }

          }
        }
      }

      that.$nextTick(()=>{
        let precession = document.getElementById(divId)
        let pd = this.$echarts.init(precession)
        let pdtion = {
          grid:{
            left:40,
            right:60,
            bottom:58,
            top:20
          },
          animation: false,
          tooltip: {
            show:false
          },
          xAxis: [{
            position:'bottom',
            type: 'time',
            axisLabel:{
              formatter: function (value,index) {
                // 格式化成月/日
                let a = moment(value).format("HH:mm")
                return '{gray|'+a+'}';
              },
              rich:{
                gray: {
                  color: '#999999',
                  fontSize: 12
                },
                blue:{
                  color:'#1790FF',
                  fontSize: 14,
                  height:24,
                  backgroundColor: 'rgba(23,144,255,0.05)',
                  borderRadius: 5,
                  padding:[0,10,2,10],
                }
              },
              textStyle:{
                color:'rgba(23,114,255,1)'
              },
            },
            axisLine:{
              show:true
            },
            interval:3600*1000,
            z:2
          },{
            position:'top',
            type: 'time',
            axisLabel:{
              show:false
            },
            axisLine:{
              show:true
            },
          }],
          yAxis:[{
            type: 'value',
            max:Math.ceil(that.basicInfo.highBlood*1.5),
            min:0,
            show: true,
            axisLabel:{
              show:true
            },
            splitLine:{
              show:false
            },
            axisLine:{
              show:true,
              lineStyle:{
                color:"#999999"
              }
            }
          },{
            type: 'value',
            max:Math.ceil(that.basicInfo.highBlood*1.5),
            min:0,
            show: true,
            axisLabel:{
              show:false
            },
            splitLine:{
              show:false
            },
            axisLine:{
              show:true,
              lineStyle:{
                color:"#999999"
              }
            }
          }],
          series:[
            {
              name: '血糖',
              type: 'line',
              data: chartDataDay,
              symbol:'none',
              itemStyle : {
                normal: {
                  lineStyle: {
                    color: 'rgba(23,114,255,1)'
                  }
                }
              },
              markPoint:{
                symbolSize:30,
                data:markPointDataDay,
                itemStyle:{
                  color:'#FF5E5E'
                }
              },
              areaStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: '#DCF3FE' // 0% 处的颜色
                  }, {
                    offset: 1, color: '#FFFFFF' // 100% 处的颜色
                  }],
                  global: false // 缺省为 false
                }
              }
            },
          ]
        };
        pd.setOption(pdtion)
      });

    },
    handleTIRData(){
      let TAR139 = [];
      let TAR10 = [];
      let TIR3910 = [];
      let TBR39 = [];
      let TBR10 = [];

      let times = [];
      let i = 0;
      for(i = 0;i<this.TIRs.length;i++){
        if(i === this.TIRs.length - 1){
          TAR139.unshift(this.TIRs[i].percent139);
          TAR10.unshift(this.TIRs[i].percent100);
          TIR3910.unshift(this.TIRs[i].percentTir);
          TBR39.unshift(this.TIRs[i].percent39);
          TBR10.unshift(this.TIRs[i].percent30);
          times.unshift(this.TIRs[i].day);
        }else {
          TAR139.push(this.TIRs[i].percent139);
          TAR10.push(this.TIRs[i].percent100);
          TIR3910.push(this.TIRs[i].percentTir);
          TBR39.push(this.TIRs[i].percent39);
          TBR10.push(this.TIRs[i].percent30);
          times.push(this.TIRs[i].day.slice(5));
        }

      }


      this.$nextTick(() => {
        let tirChart = document.getElementById('TIRChart');
        let myChart4 = this.$echarts.init(tirChart);
        myChart4.setOption({
          grid:{
            bottom:'15%',
            left:90,
            right:65
          },
          animation: false,
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross'
            },
            formatter(params) {
              // console.log(params);
              const item = params[params.length-1];
              if (item.data.value.length > 1) {
                return `${item.data.name}<br/>${item.data.value[1]} mmol/L`;
              }
            },
            show:false
          },
          xAxis: {
            type: 'category',
            axisLabel:{
              formatter: function (value,index) {
                return value;
              },
              rich:{
                gray: {
                  color: '#999999',
                  fontSize: 12
                },
                blue:{
                  color:'#1790FF',
                  fontSize: 14,
                  height:24,
                  backgroundColor: 'rgba(23,144,255,0.05)',
                  borderRadius: 5,
                  padding:[0,10,2,10],
                }
              },
              textStyle:{
                color:'#999999',
                fontSize:14
              },
            },
            data:times,
            axisTick:{
              show:false
            },
            axisLine:{
              show:false
            }
          },
          yAxis:{
            type: 'value',
            max:100,
            min:0,
            name:'%',
            splitNumber:5,
            splitLine: {
              show:true,
              lineStyle:{
                type:'dashed',
                color:'#d5d5d5'
              }
            },
            axisTick:{
              show:false,
            },
            axisLine:{
              show:false
            },
            show: true,
            axisLabel:{
              textStyle:{
                color:'#666666',
                fontSize: 16
              },
            },
            z:2
          },
          series:[{
            type:'bar',
            data:TBR10,
            stack:'total',
            itemStyle:{
              color:'#F68D16'
            },
            barWidth:18,
            markArea:{
              data: [[{
                yAxis: 0
              }, {
                yAxis: 100
              }]],
              itemStyle:{
                color:'#F8F8F8',
              },
              silent:true
            }
          },{
            type:'bar',
            data:TBR39,
            stack:'total',
            itemStyle:{
              color:'#F6BD16'
            },
            barWidth:18
          },{
            type:'bar',
            data:TIR3910,
            stack:'total',
            itemStyle:{
              color:'#3ACB9E'
            },
            barWidth:18
          },{
            type:'bar',
            data:TAR10,
            stack:'total',
            itemStyle:{
              color:'#3FA3FF'
            },
            barWidth:18
          },{
            type:'bar',
            data:TAR139,
            stack:'total',
            itemStyle:{
              color:'#6D57FF'
            },
            barWidth:18
          }]
        });

      });

    },
    close() {
      this.$emit('close')
      this.visible = false
      this.tabKey = '1'
    },
  },
}
</script>

<style lang="less" scoped>
.update11{
  margin-left: 60px;
}
.TIR-label{
  font-size: 17px;
  font-weight: 500;
  color: #333333;
}
.select-all{
  margin-left:10px;
  font-size: 22px;
  font-weight: 500;
  color: #666666;
  line-height: 30px;
}
.print-options{
  display:flex;
  margin-top:38px;
  align-items:center;
  margin-left:133px
}
.print-table{
  height:312px;
  overflow-x:hidden;
  margin-left:63px
}
.low-percent{
  width:292px;
}
.high-percent{
  width:308px;
}
.wear-time{
  width:270px;
}
.date-date{
  width:242px;
}
.choose{
  width:162px;
}
.table-day{
  display:flex;
  height:52px;
  width:fit-content;
  background: #F1F6FA;
  margin-left:63px;
  margin-top:53px
}
.TIRChart{
  height:500px;
}
.table-date{
  display:flex;
  align-items:center;
  flex-direction:row;
  border: 1px solid #999999;
  padding:11px 50px;
}
.chart-date{
  width:fit-content;
  background: #3ACB9E;
  border-radius: 18px;
  font-size: 21px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 29px;
  padding:4px 15px;
  margin-left:42px
}
.dayChart{
  width: 800px;
  height:200px;
}
.update10{
  height: 700px;
  overflow: scroll
}
.chart24hours{
  width: 1600px;
  height:450px;
  margin-top:50px
}
.target{
  font-size: 12px;
  font-weight: 400;
  color: #009CEE;
  line-height: 17px;
  margin-top:13px;
  margin-bottom:13px
}
.update9{
  margin-left:40px;
  margin-top:40px
}
.update8{
  height: auto;
  overflow: scroll;
}
.lian-xu{
  width: 1800px;
  height:350px;
}
.update7{
  margin-left:40px;
  margin-top:37px;
}
.update6{
  margin:0 60px
}
.update5{
  margin-top: 20px
}
.line_dv{
  width: 394px;
  height: 80%
}
.just-margin{
  margin-left: 103px
}
.line-style{
  width: 1px;
  background-color: #999999;
  margin-left: 109px;
  margin-top: 65px;
  height: 457px
}
.line-style-1{
  width: 1px;
  background-color: #999999;
  margin-top: 65px;
  height: 457px
}
.update1{
  margin-left: 160px;
}
.update2{
  margin-top: 61px;
  margin-left: 60px
}
.update3{
  margin-top: 61px
}
.update4{
  margin-top: 79px;
  margin-left: 50px;
}
.card-container {
  background: #f5f5f5;
  overflow: hidden;
  padding: 24px;
}
.card-container > .ant-tabs-card > .ant-tabs-content {
  height: 120px;
  margin-top: -16px;
}

.card-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
  background: #fff;
  padding: 16px;
}

.card-container > .ant-tabs-card > .ant-tabs-bar {
  border-color: #fff;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  border-color: transparent;
  background: transparent;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
  border-color: #fff;
  background: #fff;
}

.ant-tabs-nav-scroll {
  margin: auto;
  width: 300px;
}

.agp-container {
  border-style: solid;
  border-color: #5eaaf6;
  border-width: 1px;
}

.agp-title {
  background: #5eaaf6;
  color: white;
  padding-left: 5px;
}

.agp-box {
  margin-top: 30px;
  margin-left: 10px;
  margin-right: 10px;
}

.chartLabel {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 61px;
  font-size: 16px;
  color: #999999;
  letter-spacing: -0.32px;
  line-height: 22px;
}

.aaa {
  border-radius: 4px;
  border: 1px solid #1890ff;
  font-size: 15px;
  font-weight: 400;
  color: #1790ff;
}

.bbb {
  display: none;
}

.modalSty {
  background-color: yellow;
}
.modalSty .ant-modal-body {
  padding: 0px;
}
.modalSty .ant-modal-title {
  color: yellow;
  font-size: 15px;
  line-height: 5px;
}
.modalSty .ant-modal-close-x {
  width: 40px;
  height: 40px;
  color: green;
  line-height: 40px;
}
.info {
  background: #1790ff;
  border-radius: 17px;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
  line-height: 22px;
  padding: 5px 15px 5px 15px;
}
.rep-title {
  font-size: 32px;
  font-weight: 500;
  color: #000000;
  line-height: 45px;
}
.small-point {
  width: 6px;
  height: 6px;
  background: #1cafff;
  border-radius: 50%;
}
.info-text {
  font-size: 18px;
  font-weight: 400;
  color: #666666;
  line-height: 27px;
}
.info-text-1 {
  font-size: 18px;
  font-weight: 400;
  color: #333333;
  line-height: 27px;
}
.chart-border {
  height: 987px;
  border-radius: 16px;
  border: 1px solid #999999;
  margin-top: -25px;
  position: relative;
}

.chart-border-2{
  height: 650px;
  border-radius: 16px;
  border: 1px solid #999999;
  margin-top: -25px;
  position: relative;
  overflow: scroll;
}

.chart-border-2::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

.chart-content::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

.chart-title {
  width: 670px;
  height: 51px;
  background: #009cee;
  border-radius: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 28px;
  font-weight: 400;
  color: #ffffff;
  line-height: 40px;
  margin: 0 auto;
  z-index: 2;
  position: relative;
}

.chart-1 {
  display: flex;
}
.chart-1-label-data {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.chart-number {
  font-size: 66px;
  font-weight: 300;
  color: #333333;
  line-height: 92px;
}

.chart-number-1{
  font-size: 36px;
  font-weight: 300;
  color: #333333;
  line-height: 50px;
}

.chart-unit {
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  line-height: 25px;
}

.chart-unit-1 {
  font-size: 12px;
  font-weight: 600;
  color: #999999;
  line-height: 17px;
  margin-top: 2px;
}

.chart-des {
  margin-top: 22px;
  font-size: 18px;
  font-weight: 400;
  color: #666666;
  line-height: 25px;
}

.chart-des-1{
  font-size: 15px;
  font-weight: 400;
  color: #666666;
  line-height: 21px;
  margin-top:9px;
  text-align: center;
}

.chart2-title{
  font-size: 26px;
  font-weight: 500;
  color: #333333;
  line-height: 37px;
  margin-left: 11px;
}
.chart2-lengend{
  font-size: 15px;
  font-weight: 400;
  color: #333333;
  line-height: 21px;
  margin-left: 4px;
}
.blue-radius{
  background: #009CEE;
  border-radius: 10px;
  padding:0 8px;
  font-size: 15px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 21px;
}
.table-title{
  display:flex;
  align-items:center;
  justify-content: center;
  font-size: 22px;
  font-weight: 500;
  color: #666666;
  background: #F1F6FA;
}

.table-number{
  display:flex;
  align-items:center;
  justify-content: center;
  font-size: 22px;
  font-weight: 400;
  color: #666666;
  line-height: 30px;
}

.table-number-print{
  display:flex;
  align-items:center;
  justify-content: center;
  font-size: 22px;
  font-weight: 400;
  color: #009CEE;
  line-height: 30px;
}

.button-enable{
  pointer-events: auto;
  cursor:pointer;
  background: #009CEE;
  border-radius: 12px;
  display:flex;
  font-size: 22px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 30px;
  padding:11px 25px;
  margin-left:78px;
}

.button-disable{
  pointer-events: none;
  cursor:pointer;
  background: rgba(0,156,238,0.3);
  border-radius: 12px;
  display:flex;
  font-size: 22px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 30px;
  padding:11px 25px;
  margin-left:78px;
}
</style>



// WEBPACK FOOTER //
// src/components/Report.vue